/*!
 * Manera Product Reader
 * 
 */
var manera = {
    clicker: $('.photos .image_container'),
    closer: $('.openseadragon__close'),
    openseadragon: $('#openseadragon'),
    header: $('.product_header'),
    zoomIn: function (index) {
        //console.log('complete zomming in');
        window.viewer.goToPage(index);
        this.openseadragon.addClass('active');
        this.closer.addClass('active');
        TweenMax.to(this.openseadragon, .5, {opacity: 1, ease: Power2.easeInOut});
        TweenMax.to(this.closer, .6, {opacity: 1, ease: Power2.easeInOut});
    },
    zoomOut: function () {
        this.openseadragon.removeClass('active');
        this.closer.removeClass('active');
        TweenMax.to(this.openseadragon, .5, {opacity: 0, ease: Power2.easeInOut});
        TweenMax.to(this.closer, .6, {opacity: 0, ease: Power2.easeInOut});
        TweenMax.to(this.header, .5, {opacity: 1, ease: Power2.easeInOut});
    }
};
$(document).ready(function(){
    //couleurs produits vue produit
    if($('body').hasClass('readermode'))
    {
        var currentColor = "#"+$('li.couleur.active').data('bg');
        TweenMax.to('#wrapper',.5,{backgroundColor: currentColor,ease:Power3.easeOut});
        TweenMax.to('#openseadragon',.5,{backgroundColor: currentColor,ease:Power3.easeOut});

        $('li.couleur').on('click',function(e) {
            var item = $(this).data('item');
            var bg = "#"+$(this).data('bg');
            TweenMax.to('#wrapper',.5,{backgroundColor: bg,ease:Power3.easeOut});
            TweenMax.to('#openseadragon',.5,{backgroundColor: bg,ease:Power3.easeOut});
            //TweenMax.to('.product_full',.5,{backgroundColor: bg,ease:Power3.easeOut});

            $('.color-name').removeClass('d-inline-block').addClass('d-none');
            $('[data-color_name="'+item+'"]').removeClass('d-none').addClass('d-inline-block');
        });
    }
    /** ANIM CHIFFRES SUR PAGE PRODUIT *****/
    if($('.product_details').length > 0) {
        var waypointCaracteristics = new Waypoint({
            element: $('.product_details'),
            handler: function (direction) {
                if (direction == "down") {
                    var valueDisplay = $('.caracteristics .item .value');
                    var obj = {value: 0};
                    valueDisplay.each(function () {

                        var stopValue = $(this).data('value');
                        TweenMax.to(obj, 1.5, {
                            value: stopValue,
                            //roundProps: {value: 1},
                            roundProps: "value",
                            onUpdate: updateHandler,
                            onUpdateParams: [$(this).find('span'), obj],
                            ease: Linear.easeNone
                        });
                    });
                }
            },
            offset: '50%'
        });
    }
    function updateHandler(elem,startValue){
        elem.text(startValue.value);
    }

    //sizechart btn
    $(document).on('mouseenter','.sizechart_link_style',function()
    {
        var line = $(this).find('.line');
        TweenMax.to(line,.3,{x:"100%"}),
        TweenMax.fromTo(line,.3,{x:"-100%"},{x:"0%",ease:Power1.easeOut,delay:.3});
    });






    if($('.gallery').length > 0)
    {
        $('.gallery-for').on('init', function(event,slick){
            var text = '<span class="current">1</span> | ' + slick.slideCount;
            $('.small_gallery .custom-dots').html(text);

            var video = $(slick.$slides.get(0)).find(':not(picture) > video, :not(picture) > audio');
            if( video.length > 0)
                video[0].play();
            console.log('init');
        });
        var main_gallery = $('.gallery-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows : true,
            appendArrows: $('.small_gallery .slick-pagination'),
            prevArrow: '<span class="slick-prev"><svg viewBox="0 0 6 9" xmlns="http://www.w3.org/2000/svg"><path d="M5.134 0L1 4.5 4.976 9" stroke="#000" fill="none" fill-rule="evenodd"/></svg><div class="trait"></div></span>',
            nextArrow: '<span class="slick-next"><svg viewBox="0 0 6 9" xmlns="http://www.w3.org/2000/svg"><path d="M.866 9L5 4.5 1.024 0" stroke="#000" fill="none" fill-rule="evenodd"/></svg><div class="trait active"></div></span>',
            dots: false,
            fade: false,
            infinite: true,
            asNavFor: '.gallery-nav'

        });


        var nav_gallery = $('.gallery-nav').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            //initialSlide: 1,
            dots: false,
            arrows: false,
            focusOnSelect: true,
            infinite: true,
            asNavFor: '.gallery-for'
        });

        main_gallery.on('afterChange',function(event,slick,currentSlide,nextSlide){
            var text = '<span class="current">'+(currentSlide+1) + '</span>|' + slick.slideCount;
            $('.small_gallery .custom-dots').html(text);
            var video = $(slick.$slides.get(currentSlide)).find(':not(picture) > video, :not(picture) > audio');
            if( video.length > 0)

                video[0].play();
        });
        nav_gallery.on('afterChange', function(event, slick,currentSlide, nextSlide){
            var video = $(slick.$slides.get(currentSlide)).find(':not(picture) > video, :not(picture) > audio');
            if( video.length > 0)
                video[0].play();
        });
    }
    if($('#openseadragon').length > 0)
    {
        var headerHeight = $('#header').height();

        $('.product_full #openseadragon').css('top',-(headerHeight));

        var tiles = window.maneratiles;
        window.viewer = OpenSeadragon({
            id: "openseadragon",
            tileSources: tiles,
            preload: true,
            showZoomControl: false,
            showHomeControl: false,
            showFullPageControl: false,
            showRotationControl: false,
            showSequenceControl: false,

        });

        var opensea_closer = $('.openseadragon__close');
        $('.product_picture').on('click', function()
        {
            var index = $(this).index();
            TweenMax.to($('.product_header'),.5,{opacity:0, ease: Power2.easeInOut, onComplete:manera.zoomIn(index)});

        });
        opensea_closer.on('click',function(e){
            e.preventDefault();
            manera.zoomOut();
            // window.viewer.destroy(); viewer = null;
        });
    }

    /**technos nav ***/

    var technos = $('div[id^="element_"]');
    if(technos.length > 0)
    {
        var technosController = new ScrollMagic.Controller();
        var nav = $('<nav/>').addClass('techno_nav d-none d-md-block');
        var label = $('<p/>').addClass('label');
        //nav.prepend(label);
        //var first = $('<li/>').addClass('first').prepend(label);
        var ul = $('<ul/>');

        technos.each(function(e,i){
            var elem = $(this);
            var elemId = elem.prop('id');
            var li = $('<li/>').attr('data-element',elemId);
            var span = $('<i/>');
            var p = $('<p/>').append(elemId);
            li.append(span).append(p);
            ul.append(li);
        });
        //ul.prepend(first);

        nav.prepend(label).append(ul);

        $('.product__technologies').prepend(nav);
        //create scenes for scroll spy
        technos.each(function(index,value){
            //console.log(index);
            var elem = $(this);
            var elemId = elem.prop('id');
            var element = $('[data-element="'+elemId+'"]');
            var title = elem.find('h3').text();
            if(index > 0)
            {
                var prev = technos[index-1];
                var prevTitle = $(prev).find('h3').text();
                var prevlist = element.prev();
            }


            var scene = new ScrollMagic.Scene({
                triggerElement: elem,
                duration : $(this).parent().outerHeight(true)
            });


            scene.on('start',function(e) {
                var direction = e.target.controller().info('scrollDirection');
                //console.log(direction);
                if(e.type == "start")
                {
                    $('.techno_nav li').removeClass('active');
                    element.addClass('active');
                    changeTitle(title);
                }
                if(e.type == "start" && direction == "REVERSE")
                {
                    if(index > 0)
                    {
                        element.removeClass('active');
                        prevlist.addClass('active');
                        changeTitle(prevTitle);
                    }
                }

            });

            //scene.addIndicators()
            scene.addTo(technosController);

        });
        function changeTitle(title)
        {
            $('.techno_nav .label').text(title);
        }
        //at loading
        var title = $(technos[0]).find('h3').text();
        changeTitle(title);
        var labelH = $('.techno_nav .label').width()+117;
        $('.techno_nav').css('top',labelH);
        var currentLabel;
        //on click
        $('.techno_nav li').on('click',function(e){
            currentLabel = $('.techno_nav .label').text();
            var elem = $(this).data('element');
            var title = $('#'+elem).find('h3').text();
            changeTitle(title);

            $('.techno_nav li').removeClass('active');
            $(this).addClass('active');
            TweenMax.to(window,1, {scrollTo:{y:"#"+elem}});
        });

        $('.techno_nav li').hover(function(){
            currentLabel = $('.techno_nav .label').text();
            var elem = $(this).data('element');
            var title = $('#'+elem).find('h3').text();
            changeTitle(title);
        }, function(){
            changeTitle(currentLabel);
        });

        /*var lastItem = $('.product__technologies').children().last();
        var pos = lastItem.position();*/

        /*var product_techno = $('.product__technologies').height();
        //console.log("on dom "+product_techno);
        var technosNav = new ScrollMagic.Scene({
            triggerElement: $('.techno_nav'),
            duration: product_techno,
            //duration: pos.top,
        }).setPin($('.techno_nav'))
            .addTo(technosController);*/


        /*var technosColors = new ScrollMagic.Scene({
            triggerElement: $('.blackbackground')
        }).setClassToggle($('.techno_nav'),'white').addTo(technosController);*/
        /* var technosScrollSpy = new ScrollMagic.Scene({
             triggerElement: $('[id^="element_"]')
         }).setClassToggle().addTo(technosController);*/

        /*var techno_waypoints = new Waypoint({
            element: $('.blackbackground'),
            handler : function(direction){
                console.log("coucou");
                if(direction == "down")
                    $('.techno_nav').addClass('white');
                else
                    $('.techno_nav').removeClass('white');
            },
            //continuous: false
           // offset: '50%'
        });*/

        // $('.techno_nav').midnight();
    }
    //$('.mod_rocksolid_slider').on('rsts-slidestart', function(event) {
    $('.mod_rocksolid_slider').on('rsts-slidestart', function(event) {
        event.rstSlider.slides[event.rstSlider.slideIndex]
            .element.find(':not(picture) > video, :not(picture) > audio')
            .mediaelementplayer({
                pluginPath: '/assets/mediaelement/plugins/',
                stretching: 'responsive',
            });
    });


});

$(window).load(function(){
    /** handle product details  slide left/right **/
    if($('#twenty').length > 0) {
        $("#twenty").twentytwenty({
            no_overlay: true,
        });
    }

   // pdt360DegViewer('interactive_3d', 25, 'files/manera/produits/harnesses/union/videos/union360-3/', 'jpg', false, false, true, false, false, false, false);
    setTimeout(function() {
        var product_techno = $('.product__technologies').height();
        var nav_height = $('.techno_nav').height();

        var lastItem = $('.product__technologies').children().last();
        //var pos = lastItem.position();
        var navTechController = new ScrollMagic.Controller();
        var technosNav = new ScrollMagic.Scene({
            triggerElement: $('.techno_nav'),
            duration: (product_techno-nav_height-lastItem.height()-120),
            //duration: pos.top,
        }).setPin($('.techno_nav'))
            .addTo(navTechController);
    }, 10);

    if ($('#interactive_3d').length > 0) {
        var nbframes = $("#interactive_3d").data('frames');
        $("#interactive_3d").interactive_3d({
            frames: nbframes, // The total number of images to be used as frames. The higher, the smoother your interaction will be. The default value is 10 frames.
            entrance: false, // Entrance Animation. Toggle this to false to turn it off. The default value is true.
            preloadImages: true, // Let the script preload all the frames on initial load. Toggle this to false to turn it off. The default value is true.
            loading: "Loading..", // This only applies if preloadImages is true. This option let you show a loading indicator while the script is preloading the images. The option accepts HTML. Toggle this to false to turn this off. The default value is "Loading.."
        });
    }
});